import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config/apiConfig';

const SettingsPage = () => {
    const [settings, setSettings] = useState({
        defaultQuota: 30,
        resetDay: 1, // Premier jour du mois
        maxFileSizeMB: 5,
        allowedFileTypes: '.pdf,.jpg,.png,.doc,.docx'
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings({
            ...settings,
            [name]: name === 'defaultQuota' || name === 'resetDay' || name === 'maxFileSizeMB'
                ? parseInt(value, 10)
                : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const authToken = JSON.parse(localStorage.getItem('authToken') || '{}');
            await axios.post(`${API_URL}/admin/settings`, settings, {
                headers: {
                    Authorization: `Bearer ${authToken.token}`
                }
            });

            setSuccess(true);
        } catch (error) {
            console.error('Erreur lors de la mise à jour des paramètres:', error);
            setError('Erreur lors de la mise à jour des paramètres');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 className="text-2xl font-semibold text-gray-700 mb-6">Paramètres</h1>

            <div className="bg-white rounded-lg shadow p-6">
                <form onSubmit={handleSubmit}>
                    <div className="space-y-6">
                        <div>
                            <label htmlFor="defaultQuota" className="block text-sm font-medium text-gray-700">
                                Quota mensuel par défaut
                            </label>
                            <input
                                type="number"
                                id="defaultQuota"
                                name="defaultQuota"
                                value={settings.defaultQuota}
                                onChange={handleChange}
                                min="1"
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                        </div>

                        <div>
                            <label htmlFor="resetDay" className="block text-sm font-medium text-gray-700">
                                Jour de réinitialisation du quota (1-28)
                            </label>
                            <input
                                type="number"
                                id="resetDay"
                                name="resetDay"
                                value={settings.resetDay}
                                onChange={handleChange}
                                min="1"
                                max="28"
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                        </div>

                        <div>
                            <label htmlFor="maxFileSizeMB" className="block text-sm font-medium text-gray-700">
                                Taille maximale des fichiers (MB)
                            </label>
                            <input
                                type="number"
                                id="maxFileSizeMB"
                                name="maxFileSizeMB"
                                value={settings.maxFileSizeMB}
                                onChange={handleChange}
                                min="1"
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                        </div>

                        <div>
                            <label htmlFor="allowedFileTypes" className="block text-sm font-medium text-gray-700">
                                Types de fichiers autorisés
                            </label>
                            <input
                                type="text"
                                id="allowedFileTypes"
                                name="allowedFileTypes"
                                value={settings.allowedFileTypes}
                                onChange={handleChange}
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                            <p className="mt-1 text-sm text-gray-500">Séparés par des virgules (ex: .pdf,.jpg,.png)</p>
                        </div>

                        {success && (
                            <div className="p-4 bg-green-100 rounded-md">
                                <p className="text-sm text-green-700">
                                    Paramètres enregistrés avec succès !
                                </p>
                            </div>
                        )}

                        {error && (
                            <div className="p-4 bg-red-100 rounded-md">
                                <p className="text-sm text-red-700">{error}</p>
                            </div>
                        )}

                        <div className="flex justify-end">
                            <button
                                type="submit"
                                disabled={loading}
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-[#3D5A80] hover:bg-[#2b3f59] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                {loading ? 'Enregistrement...' : 'Enregistrer les paramètres'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SettingsPage;